// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"862cef4b","362":"24fdd74a","381":"ac7fe804","640":"f83b1d9e","787":"898bfd65","820":"3b09d9e3","888":"327baac1","961":"9558b6a3"}[chunkId] + ".chunk.js";
};